import React from "react";

export default () => (
  <div className="publicPage">
    <div className="publicPage__card">
      <div className="publicPage__content">
        <div className="publicPage__row">
          <div className="publicPage__label">Datová sada</div>
          <a
            className="publicPage__link"
            href="/verejnost/api/funkcionari/opendata/export"
            target="_blank"
            rel="noreferrer"
          >
            data.csv
          </a>
        </div>

        <div className="publicPage__row">
          <div className="publicPage__label">Metadata</div>
          <a
            className="publicPage__link"
            href="/verejnost/api/funkcionari/opendata/metadata"
            target="_blank"
            rel="noreferrer"
          >
            metadata.json
          </a>
        </div>
      </div>
    </div>
  </div>
);
